import { StaticImage } from 'gatsby-plugin-image'
import React, { useState } from 'react'
import { useRef } from 'react'
import second from '../../images/Play.png'

const SimpleVideoBlock = ({ attributes }) => {
    const videoRef = useRef(null)
    const [isPlaying, setIsPlaying] = useState(false)
    const handleVideo = () => {
        videoRef?.current?.play()
        setIsPlaying(true)
    }
    return (
        <div className="container">
            <div className="aspect-[816/481] relative rounded-[10px] overflow-hidden">
                {!isPlaying && (
                    <div className="absolute inset-0 grid place-items-center z-10">
                        <div
                            className="grid place-items-center cursor-pointer w-16 aspect-square rounded-full bg-black/20"
                            onClick={handleVideo}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="white"
                                className="w-8"
                            >
                                <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                            </svg>
                        </div>
                    </div>
                )}

                <video
                    className="w-full h-full"
                    poster={attributes?.poster}
                    ref={videoRef}
                    controls={isPlaying}
                >
                    <source src={attributes?.src} type="video/mp4"></source>
                </video>
            </div>
        </div>
    )
}

export default SimpleVideoBlock
